import React, { useEffect, useCallback, useMemo } from "react";
import axios from "axios";

/*BootstrapTable anbd table Related*/
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

/*Other Components*/

/*Loader */

/*animation*/
/*Inputs*/
/*Styles*/
import "./AgentStatistics.css";

export default function AgentStatistics(props) {
  const { agentStats } = props;

  const formatStats = (input) => {
    if (!input) return {}
    // Destructure the input object for easier access to its properties
    const {
      currentBalance,
      lastWeekMakeUp,
      makeUp,
      ytdWin,
      ytdLose,
      ytdComm,
      lifetimeWin,
      lifetimeLose,
      lifeTimeComm,
      accountOpened,
      lastWeek,
      thisWeek,
    } = input;

    // Calculate the Lifetime Net and Total for the last and this week
    const ytdNet = ytdWin + ytdLose;
    const lifetimeNet = lifetimeWin + lifetimeLose;

    // Format dates into a more readable format if necessary
    const formatDate = (dateString) =>
      dateString ? new Date(dateString).toLocaleString() : "";

    // Return the new object with keys as displayed in the image
    // TODO-Gabo: Missing
    // FreePlay
    // AvailBalance should add the credit limit
    return {
      "Current Balance": formatNumber(currentBalance),
      MakeUp: "",
      "- Last Week": formatNumber(lastWeekMakeUp),
      "- Current": formatNumber(makeUp),
      " ": "",
      "YTD Win": formatNumber(ytdWin),
      "YTD Lose": formatNumber(ytdLose),
      "YTD Net": formatNumber(ytdNet),
      "YTD Comm": formatNumber(ytdComm),
      "  ": "",
      "Lifetime Win": formatNumber(lifetimeWin),
      "Lifetime Lose": formatNumber(lifetimeLose),
      "Lifetime Net": formatNumber(lifetimeNet),
      "Lifetime Comm": formatNumber(lifeTimeComm),
      "   ": "",
      "Account Opened": formatDate(accountOpened),
      "    ": "",
      "Two Weeks Ago": formatNumber(lastWeek),
      "Last Week": formatNumber(thisWeek),
    };
  };

  const formatNumber = (num) => {
    if (num == null || isNaN(num)) return "0";

    const roundedNum = Math.round(num);

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(roundedNum);
  };;

  const agentInfo = useMemo(() => {
    if (!agentStats) return [];

    return Object.entries(formatStats(agentStats)).map(([key, value]) => ({
      key,
      value,
    }));
  }, [agentStats]);


  const statFormater = (cell) => (
    <span className="text-sm font-semibold">{cell}</span>
  );

  return (
    <div className="flex flex-col items-center justify-center">
      <BootstrapTable className="w-80 min-w-min hidden-header" data={agentInfo}>
        <TableHeaderColumn
          isKey={true}
          dataField="key"
          dataFormat={statFormater}
        >
          Statistics
        </TableHeaderColumn>
        <TableHeaderColumn dataField="value" dataFormat={statFormater} width="150"></TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}
